import React from 'react';
import { Modal } from 'antd';
import { APPROACHES_HELP_MODAL_TEXT } from '../../constants';

const ApproachesHelpModal = ({ isVisible, onClose }) => (
  <>
    <Modal
      title="Controls Help"
      visible={isVisible}
      onOk={onClose}
      onCancel={onClose}
      style={{ top: '25%' }}
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <ul style={{ listStyle: 'none' }}>
        {APPROACHES_HELP_MODAL_TEXT.map((text, i) => (
          <li key={i}>{text}</li>
        ))}
      </ul>
    </Modal>
  </>
);

export default ApproachesHelpModal;
